// @ts-nocheck
import Ajax, { refreshToken } from '../Ajax'
import { add } from 'date-fns'
import { store } from './Store'
import { Alert, AlertModal } from '..'
import { makeAutoObservable, reaction } from 'mobx'
import { StateChange } from '../models/StateChange'
import { InformationRequest } from '../models/InformationRequest'
import PopupRequestForm from '../components/form/PopupRequestForm'
import signalR, { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import EnquiryOutcomeModal from '../components/views/main/detail/enquiry/EnquiryOutcomeModal'


export class ConnectionStore {

    hubConnection: HubConnection | null = null;
    connectionState: string | null = null;
    waiting: string[] = [];
    
    ndConnectionLastTestedAt: Date = null
    ndConnectionTestPending: boolean = false
    ndConnectionTestIntervalSeconds: number = 180
    
    wsConnectionLastTestedAt: Date = null;
    wsConnectionTestPending: boolean = false;
    wsConnectionTestIntervalSeconds: number = 15;
    wsConnectionTestsVerified: number = 0;
    
    transportTypes = {
        "0": "Automatic",
        1: "WebSockets (recommened)",
        2: "Server Sent Events",
        4: "Long Polling (not recommended)"
    }
    transportType: "0" | 1 | 2 | 4 = "0"

    constructor() {
        makeAutoObservable(this)

        reaction(() => this.hubConnection?.state, state => {
            this.connectionState = state
        })

        window.onmouseover = async () => {

            if (!store.AppStore.isLoggedIn) {
                return
            }
            // Make this request to stop the ND server from timing out.
            // A user can become inactive on the ND while still being active on 
            // Other features like questionnaires and automations.
            if (!this.ndConnectionLastTestedAt || add(this.ndConnectionLastTestedAt, {seconds: this.ndConnectionTestIntervalSeconds}) < new Date()) {
                this.testNdConnection()
            }
        
            if (!this.wsConnectionLastTestedAt || add(this.wsConnectionLastTestedAt, {seconds: this.wsConnectionTestIntervalSeconds}) < new Date()) {
                this.testWsConnection(1)
            }
        }
    }

    testNdConnection = async () => {
        
        if (this.ndConnectionTestPending) {
            return
        }

        var logUid = Math.round(Math.random() * 1000)
        console.log(logUid, "Testing ND connection")
        this.ndConnectionLastTestedAt = new Date()
        this.ndConnectionTestPending = true
        
        if (store.AppStore.sessionInfo?.userUid) {
            await Ajax.Node.Get(store.AppStore.sessionInfo.userUid).then(() => {
                console.log(logUid, "ND connection OK")
            }).catch(() => {
                console.log(logUid, "ND connection failed")
            })
            
            this.ndConnectionTestPending = true
        }
    }

    testWsConnection = async (wsConnectionTestCount) => {

        if (this.wsConnectionTestPending) {
            return
        }

        var logUid = Math.round(Math.random() * 1000)
        console.log(logUid, "Testing websockets connection")

        this.wsConnectionTestsVerified = 0
        this.wsConnectionTestPending = true
        this.wsConnectionLastTestedAt = new Date()

        if (!this.hubConnection) {
            await this.createHubConnection()
        }
        
        await Ajax.Message.Test(wsConnectionTestCount).then(() => {
            setTimeout(async () => {
                // If no test websockets messages are received
                if (this.wsConnectionTestsVerified > 0) {
                    console.log(logUid, "Websockets are connected")
                } else {
                    console.log(logUid, "Websockets are not connected, attempting to reconnect")
                    await this.stopHubConnection()
                    await this.createHubConnection()
                }
                this.wsConnectionTestPending = false
            }, 2000)
        }).catch(() => {
            console.log(logUid, "Connection test failed")
        })
    }

    setTransportType = async (transportTypeNumber: number) => {
        await this.stopHubConnection()
        this.transportType = transportTypeNumber
        await this.createHubConnection()
    }

    handleDisconnect = (message) => {
        console.log("DisconnectNotification", message)
        store.AppStore.resetApp()
        Alert({
            message: "You have been disconnected", 
            actions: message?.length > 5 
                ? [{label: "More info", action: () => AlertModal({body: message})}] 
                : []
        })
    }

    createHubConnection = async (first_try = true) => {

        var logUid = Math.round(Math.random() * 1000)
        console.log(logUid, "Opening new SignalR connection")
        var options = {
            accessTokenFactory: async () => {
                const tokenIsValid = store.AppStore.checkJwtIsNotExpired()
                console.log(logUid, "SignalR token is valid?", tokenIsValid)
                if (!tokenIsValid) {
                    console.log(logUid, "SignalR is initiating a token refresh")
                    await refreshToken()
                }
                return window.localStorage.getItem("aora_jwt")
            }
        }

        if (this.transportType !== "0") { options["transport"] = this.transportType }

        this.hubConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_SIGNALR_URL}`, options)
            // .withAutomaticReconnect([0, 2000, 4000, 6000])
            .configureLogging(LogLevel.Information)
            .build();

        this.hubConnection.on("InformationRequestIntercepted", (iri: any) =>                    store.QuestionnaireStore.handleInformationRequestIntercepted(iri))
        this.hubConnection.on("DataSourceNotification", (message: any) =>                       store.QuestionnaireStore.handleDataSourceChangeNotification(message))
        this.hubConnection.on("InformationRequest", (message: InformationRequest) =>            store.QuestionStore.receiveInformationRequest(message))
        this.hubConnection.on("EnquiryStatusNotification", (message: any) =>                    handleEnquiryStatusNotification(message))
        // this.hubConnection.on("HighlightNotification", (message: any) =>                        console.log(logUid, message))
        this.hubConnection.on("DisconnectNotification", (message: string) =>                    this.handleDisconnect(message))
        this.hubConnection.on("CloseConnection", (message: string = "") =>                      this.stopHubConnection())
        this.hubConnection.on("StateChange", (stateChange: StateChange) =>                      store.AppStore.setSessionState(stateChange))
        this.hubConnection.on("AutomationNotification", (message: any) =>                       store.AutomationStore.handleAutomationNotification(message))
        this.hubConnection.on("PopupRequest", (popupRequest: any) =>                            handlePopupRequest(popupRequest))
        this.hubConnection.on("RunInfo", (message: string) =>                                   store.QuestionStore.handleRunInfo(message))
        this.hubConnection.on("Notify", (message: string) =>                                    Alert({ message: message }))
        this.hubConnection.on("Test", (message: string) =>                                      {
            console.log("Test message")
            this.wsConnectionTestsVerified += 1
        })

        this.hubConnection.onclose(() => {
            console.log(logUid, "SignalR connection has closed")
            this.hubConnection.stop()
            this.createHubConnection()
        });

        return await this.hubConnection.start().then(() => {
            
            this.connectionState = "Connected"
            console.log(logUid, "SignalR connection is open")
        
        }).catch(async (error) => {
            
            console.log(logUid, "SignalR connection failed", error)
        
            if (error?.statusCode === 401) {
                
                // Attempt to refresh auth token
                refreshToken().then(() => {
                    return this.createHubConnection(false) // When a new token is acquired, try again
                }).catch(() => {
                    console.log(logUid, "ConnectionStore failed to refresh token")
                })
            
            }
        })
    }

    stopHubConnection = async () =>
        await this.hubConnection?.stop().then(() => {
            this.hubConnection = null
        }).catch((error) => 
            console.log("Error stopping connection", error)
        )
}


const handleEnquiryStatusNotification = async (message) => {
    if (message?.status === "DEFINITIVE") {
        await Ajax.Node.Get(message.enquiryUid).then((response) => {
            store.NodeStore.setLeafNode(response.data)
            store.NodeStore.refreshFolderNode()
            AlertModal({id: "yes_no_outcome", body: <EnquiryOutcomeModal enquiry={response.data} />, size: "lg"})
        })
    }
}

const handlePopupRequest = (pr: any) => {
    console.log("Popup request", pr)
    tabAlert()
    AlertModal({id: pr.messageId, requireAction: true, body: <PopupRequestForm pr={pr} />})
}

const tabAlert = () => {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = '/favicon-alert.ico';
}